<template>
  <!--
    The view for the UserDependentImageOverview-component
  -->
  <div class="userDependentImageOverview">
    <UserDependentImageList
      ref="userDepententImageList"
      :theme-id="themeId" 
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :theme-id="themeId"
      :is-theme-elements="true"
      @reload="reloadLayoutElementList"
    />
  </div>
</template>

<script>
export default {
  name: "UserDependentImageOverview",
  components: {
    UserDependentImageList: () => import('@/components/VideoPostprocessing/Theme/UserDependentImageList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
  props: {
    themeId: {
      type: String,
      required: true
    }
  },
  metaInfo () {
    return {
      title: this.$t('videoPostProcessing.title')
    }
  },
  methods: {
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadLayoutElementList () {
      this.$refs.userDepententImageList.closeAndReloadData();
    },
  }
}
</script>
